"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    //simple
    {
        type: 'textfield',
        inputType: 'url',
        key: 'ariaction',
        input: true,
        weight: 5,
        label: 'Formula List API',
        tooltip: 'The API path that not included domain and API version.',
        placeholder: 'bo/bank/list',
        defaultValue: 'bp/formularfieldname/list',
        conditional: {},
    },
    //simple
    {
        type: 'textfield',
        inputType: 'url',
        key: 'formulacontrol',
        input: true,
        weight: 7,
        label: 'Formula Detail API',
        placeholder: 'bo/bank/list',
        defaultValue: 'bp/formularfieldname/detail',
        conditional: {},
    },
    {
        type: 'datagrid',
        key: 'aribody',
        input: true,
        weight: 8,
        label: 'Request message body',
        addAnother: 'Add Node',
        tooltip: 'JSON body message structure',
        components: [
            {
                key: 'path',
                label: 'Path',
                input: true,
                type: 'textfield',
                defaultValue: 'param.conditionKey'
            },
            {
                type: 'select',
                key: 'type',
                label: 'Type',
                input: true,
                dataSrc: 'values',
                data: {
                    values: [
                        { label: 'Value', value: 'value' },
                        { label: 'Data', value: 'data' },
                        { label: 'Script', value: 'script' },
                    ],
                },
                defaultValue: 'value'
            },
            {
                key: 'value',
                label: 'Value',
                input: true,
                //rows: 3,
                //editor: 'ace',
                as: 'javascript',
                type: 'textarea',
                attributes: {
                    style: 'height:calc(1.5em + .75rem + 2px)',
                },
                placeholder: '',
                defaultValue: ''
            }
        ],
        conditional: {},
    },
];
